import React from "react";
import { MessageCircle, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const categories = [{
  title: "Saúde",
  description: "Soluções avançadas de climatização e purificação para hospitais e clínicas, garantindo ambientes estéreis e seguros para pacientes e profissionais de saúde.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553755/img/clean_room_health.png",
  link: "/SolutionsPage"
}, {
  title: "Salas Limpas",
  description: "Controle rigoroso de partículas e temperatura para laboratórios e centros de pesquisa que exigem máxima pureza ambiental e conformidade técnica.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553755/img/cleanroom_environment.png",
  link: "/SolutionsPage"
}, {
  title: "Indústria",
  description: "Sistemas robustos de arrefecimento e ventilação para processos fabris complexos, otimizando a produtividade e a vida útil dos equipamentos industriais.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553755/img/industrial_hvac.png",
  link: "/SolutionsPage"
}, {
  title: "Telecomunicações",
  description: "Gerenciamento térmico de alta precisão para data centers e infraestrutura de rede, prevenindo superaquecimento e garantindo conectividade ininterrupta.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553755/img/telecom_datacenter.png",
  link: "/SolutionsPage"
}];
export default function CatalogoDeProdutos() {
  return <section data-section-id="53139" id="soluções-e-aplicações" className="bg-secondary-100 py-20 md:py-28">
      <div className="container mx-auto px-4">
        <div className="mb-16 text-center">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground font-default">
            Soluções e Aplicações
          </h2>
          <p className="mt-4 text-lg text-foreground/80 max-w-2xl mx-auto font-sans">
            Nossa tecnologia de controle térmico e purificação é aplicada em setores críticos onde a precisão e a segurança ambiental são fundamentais para o sucesso.
          </p>
        </div>

        <div className="flex flex-col gap-12">
          {categories.map((category, i) => {
          const isEven = i % 2 === 0;
          return <div key={i} data-index={i} className="group grid grid-cols-1 md:grid-cols-2 overflow-hidden rounded-lg border border-border bg-card transition-all duration-500 hover:shadow-2xs">
                {/* Image Column */}
                <div className={`relative h-64 md:h-auto overflow-hidden bg-muted ${isEven ? "md:order-1 md:border-r border-border" : "md:order-2 md:border-l border-border"} border-b md:border-b-0`}>
                  <div className="absolute inset-0 p-1">
                    <div className="h-full w-full overflow-hidden rounded-md border border-border/50">
                      <img src={category.image} alt={category.title} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                    </div>
                  </div>
                </div>

                {/* Content Column */}
                <div className={`flex flex-col justify-center p-8 md:p-12 lg:p-16 bg-card ${isEven ? "md:order-2" : "md:order-1"}`}>
                  <h3 className="text-2xl md:text-3xl font-bold font-default text-foreground tracking-tight">
                    {category.title}
                  </h3>
                  <p className="mt-4 text-foreground/70 leading-relaxed text-base md:text-lg font-sans">
                    {category.description}
                  </p>
                  <div className="mt-8 flex flex-wrap gap-4">
                    <Button asChild size="lg" className="gap-2 shadow-2xs bg-primary text-primary-foreground hover:bg-primary-600 transition-colors">
                      <Link to="/ContactPage">
                        <MessageCircle className="size-4" />
                        Solicitar Orçamento
                      </Link>
                    </Button>
                    <Button asChild variant="ghost" size="lg" className="gap-2 text-primary hover:text-primary-600 hover:bg-primary-100 transition-all">
                      <Link to={category.link}>
                        Saiba mais
                        <ArrowRight className="size-4" />
                      </Link>
                    </Button>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}